export function calPartHost() {
  let str = '.dstzc.com'
  const hostName = window.location.hostname // 域名
  if (hostName.indexOf('.dev.dstzc.com') != -1) {
    // 把原来的地址记到参数中，下一次登录成功时直接进入上一次页面，(防止因为token过期而被迫到登录页)
    str = '.dev.dstzc.com'
  } else if (hostName.indexOf('.test.dstzc.com') != -1) {
    str = '.test.dstzc.com'
  } else if (hostName.indexOf('.sit.dstzc.com') != -1) {
    str = '.sit.dstzc.com'
  } else if (hostName.indexOf('.dev2.dstzc.com') != -1) {
    str = '.dev2.dstzc.com'
  } else if (hostName.indexOf('.demo.dstzc.com') != -1) {
    str = '.demo.dstzc.com'
  } else if (hostName.indexOf('.gray.dstzc.com') != -1) {
    str = '.gray.dstzc.com'
  } else if (hostName.indexOf('.nk.dstzc.com') != -1) {
    str = '.nk.dstzc.com'
  } else if (hostName.indexOf('.bk.dstzc.com') != -1) {
    str = '.bk.dstzc.com'
  } else if (hostName.indexOf('.uat.dstzc.com') != -1) {
    str = '.uat.dstzc.com'
  } else if (hostName.indexOf('.uat2.dstzc.com') != -1) {
    str = '.uat2.dstzc.com'
  } else {
    str = '.dstcar.com'
  }
  return str
}



// WEBPACK FOOTER //
// ./src/lib/utils.js